<template>
  <div class="data-grid__FilterBuilder">
    <div class="heading__content">
      <div 
        class="filterItem"
        v-for="(rule, index) in filter.rules"
        v-show="!rule.hidden"
        :key="index">
        <div class="filterItem__label">
          {{rule.name || rule.key}}
        </div>
        <div class="filterItem__value">
          <RuleValue 
            :ruleValue="rule.value"
            :ruleOperator="rule.operator"
            :ruleKey="rule.key"
            :ruleExpression="rule.expression"
            :dataProvider="gridId"
            @change="changedRuleValue(rule, $event)"
          />
        </div>
      </div>
      <div
        class="filterBuilder__reset"
        @click="backToDefault"
        v-show="filter.rules.length !== 0"
      >
        <b-button
          variant="primary"
          size="sm"
        >
          <icon name="trash" />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import utils from "@/helpers/utils";
import RuleValue from './../../PivotGrid/FilterBuilder/RuleValue'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: {
    gridId: {
      type: String,
    },
    filter: {
      type: Object
    }
  },
  components: {
    RuleValue
  },
  mounted() {
  },
  computed: {
    ...mapState([
      'dataGrid_options'
    ]),
    ruleValue() {
      return (rule) => {
        return rule.expression ? utils.evalExpression(rule.value) : rule.value;
      }
    }
  },
  methods: {
    changedRuleValue(rule, value) {
      rule.expression = false;
      rule.value = value;
      this.emitChangeRule(rule);
    },
    emitChangeRule(rule) {
      const dataGridInst = this.$instByClass(this, 'data-grid')
      dataGridInst.applyFilterBuilder(this.filter)
    },
    getLookups (lookUpTable) {
      const lookups = []
      const {
        displayColumn,
        source,
        storageType
      } = this.dataGrid_options[lookUpTable]
      const getModel = db.dataGrid.data.getReadModel(storageType)
      const tData = getModel(source)

      for (let rowKey in tData) {
        const row = tData[rowKey]
        lookups.push({
          value: rowKey,
          name: this.$getDataGridVal(row[displayColumn])
        });
      }

      return lookups
    },
    $getDataGridVal (cell) {
      if (window.$getDataGridVal) {
        return window.$getDataGridVal(cell);
      } else {
        return cell.value
      }
    },
    backToDefault () {
      const dataGridInst = this.$instByClass(this, 'data-grid')

      try {
        if (dataGridInst.view) {
          // console.log(this.dataGrid_options[this.gridId].views[dataGridInst.view].filterBuilder, 1)
          dataGridInst.applyFilterBuilder(
            JSON.parse(this.dataGrid_options[this.gridId].views[dataGridInst.view].filterBuilder)
          )
        } else {
          // console.log(this.dataGrid_options[this.gridId], 2)
          dataGridInst.applyFilterBuilder(
            JSON.parse(this.dataGrid_options[this.gridId].filterBuilder)
          )
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss">
.data-grid {
  &__FilterBuilder {
    position: relative;
    text-transform: none;
    font-size: 14px;
    vertical-align: top;
    display: flex;

    &-toggle {
      margin-left: 15px;
      align-self: center;
    }
    .heading__content {
      display: flex;

      .filterItem {
        width: 220px;
        margin-left: 5px;
        margin-right: 5px;
        padding: {
          top: 10px;
        }
        position: relative;

        &__label {
          margin-bottom: 5px;
          font-weight: 600;
        }
      }
    }
  }
}
.filterBuilder__reset {
  padding-top: 42px;
}
</style>
